<template>
	<div id="toothRemoveButtons" class="tooth-remove-mode-item">
		<button id="toothRemoveSave" class="tooth-remove-button" 
			v-on:click="exitToothRemoveMode(true)">
			SAVE
		</button>
		<button id="toothRemoveCancel" class="tooth-remove-button" 
			v-on:click="exitToothRemoveMode(false)">
			CANCEL
		</button>
	</div>
</template>

<script>

import {
	leaveToothRemoveMode
} from "./ToothRemoveMode.js";

export default {
	name: "ToothRemoveButtons",
	props: [],
	components: {},
	methods: {
		exitToothRemoveMode: function (saveChanges) {
			leaveToothRemoveMode(saveChanges);
		}
	}
};

</script>

<style scoped>
#toothRemoveButtons {
	position: absolute;
	text-align: center;
	white-space: nowrap;
	left: calc(50% - 80px);
	bottom: 70px;
	z-index: 9;
	display: none;
	width: 200px;
	height: 35px;
}

.tooth-remove-button {
	display: inline-block;
	margin-right: 10px;
	min-width: 90px;
	width: auto;
	height: 35px;
	border: 0;
	cursor: pointer;
	font-size: small;
	background-color: #4687fc;
	text-align: center;
	color: #ffffff;
}
</style>